// extracted by mini-css-extract-plugin
module.exports = {"Coupon":"Coupon_Coupon__ai_7K"};